import { Organization, User } from '@upheal/shared/types';
import { FF_BETA_CHANNEL_CUSTOMER } from '@upheal/utils/feature-flags';
import { GQLPlanSubscriptionFragment } from '@upheal/graphql/definitions/billing/PlanSubscriptionFragment.generated';

type Subscription = GQLPlanSubscriptionFragment | null | undefined;

export const getUserProperties = (
    user?: User,
    organization?: Organization,
    subscription?: Subscription,
) => {
    const trial = subscription?.customTrial ?? subscription?.trial;
    const isOnTrial = (trial?.daysLeft ?? 0) > 0;

    return {
        isInternalUser: user?.email?.endsWith('@upheal.io'),
        userId: user?.id,
        organizationId: organization?.id,
        /**
         * Used for video session links redesign. Probably can be removed
         * once we finish the project and don't need it for it
         */
        privateRoomLink: user?.privateRoomLink
            ? new URL(user.privateRoomLink).pathname
            : null,
        organizationIdForSingleVideoLink: organization?.id,
        legacyBetaUserGroup: FF_BETA_CHANNEL_CUSTOMER.on,
        role: user?.role,
        isUphealOS: organization?.isUphealOS,
        subscriptionPlanId: subscription?.planId,
        subscriptionStatus: subscription?.status,
        isOnTrial,
    };
};
